export default __webpack_public_path__ + "static/media/cards.341372ee.png";